<template>
  <button
    class="up-logo"
    :class="{ inverse, compact }"
    type="button"
    @click="$emit('click')"
  >
    <span class="up-logo__mark">
      <img src="@/assets/rebuild/uplus-mark.png" alt="" />
    </span>
    <span class="up-logo__name">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'UPlusLogo',
  props: {
    inverse: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    label: { type: String, default: 'UPlus' }
  }
}
</script>

<style scoped>
.up-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  color: inherit;
  border: 0;
  background: transparent;
}

.up-logo__mark {
  display: grid;
  width: 32px;
  height: 32px;
  overflow: hidden;
  place-items: center;
  border-radius: 9px;
  background: linear-gradient(135deg, #4a8cff, #1252e0);
}

.up-logo__mark img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.up-logo__name {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.up-logo.inverse {
  gap: 11px;
}

.up-logo.inverse .up-logo__mark {
  width: 36px;
  height: 36px;
  overflow: visible;
  background: transparent;
}

.up-logo.inverse .up-logo__mark img {
  width: 36px;
  height: 36px;
}

.up-logo.inverse .up-logo__name {
  font-size: 20px;
}

.up-logo.compact {
  gap: 9px;
}

.up-logo.compact .up-logo__mark {
  width: 20px;
  height: 20px;
  border-radius: 6px;
}

.up-logo.compact .up-logo__mark img {
  width: 14px;
  height: 14px;
}

.up-logo.compact .up-logo__name {
  color: #586071;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
}
</style>
